import PortalIdParser from 'PortalIdParser';
import cachedHttp from 'framework-asset-preview-lib/internal/shared/api/cachedHttp';
import { OBJECT_TYPE } from 'framework-asset-preview-lib/internal/shared/constants/objectTypes';
export async function fetchTrackingUrlsAsCrmSearchResponse(campaignGuid) {
  if (!campaignGuid) {
    return Promise.resolve({
      results: [],
      total: 0,
      hasMore: false,
      offset: 0
    });
  }
  const response = await cachedHttp.get(`/tracking-url-builder/v1/tracking-urls`, {
    query: {
      campaignGuid
    }
  });
  return {
    results: response === null || response === void 0 ? void 0 : response.map(trackingUrl => {
      var _trackingUrl$shortUrl, _trackingUrl$shortUrl2;
      return {
        objectId: trackingUrl.id,
        objectTypeId: OBJECT_TYPE.TRACKING_URL,
        portalId: PortalIdParser.get(),
        properties: {
          hs_name: {
            value: trackingUrl.url || trackingUrl.trackingUrl || ((_trackingUrl$shortUrl = trackingUrl.shortUrl) === null || _trackingUrl$shortUrl === void 0 ? void 0 : _trackingUrl$shortUrl.url)
          },
          hs_lastmodifieddate: {
            value: String(trackingUrl.updatedAt)
          },
          hs_short_url: {
            value: ((_trackingUrl$shortUrl2 = trackingUrl.shortUrl) === null || _trackingUrl$shortUrl2 === void 0 ? void 0 : _trackingUrl$shortUrl2.url) || ''
          },
          hs_tracking_url: {
            value: trackingUrl.trackingUrl || ''
          },
          hs_url: {
            value: trackingUrl.url || ''
          },
          hs_origin_asset_id: {
            value: String(trackingUrl.id)
          }
        }
      };
    }),
    total: response.length,
    hasMore: false,
    offset: 0
  };
}